// Central configuration for predefined tasks
export const PREDEFINED_TASKS = [
  { value: 'development', label: 'Development', color: 'primary' },
  { value: 'design', label: 'Design', color: 'warning' },
  { value: 'testing', label: 'Testing', color: 'error' },
  { value: 'research', label: 'Research', color: 'success' },
  { value: 'meeting', label: 'Meeting', color: 'secondary' },
  { value: 'documentation', label: 'Documentation', color: 'info' },
  { value: 'admin', label: 'Administration', color: 'error' },
  { value: 'general', label: 'General', color: 'default' },
] as const;

export type PredefinedTaskColor = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' | 'default';

// Get all task values as an array
export const TASK_VALUES = PREDEFINED_TASKS.map(task => task.value);

// Get all task labels as an array  
export const TASK_LABELS = PREDEFINED_TASKS.map(task => task.label);

// Get color for a specific task
export const getTaskColor = (taskValue: string): PredefinedTaskColor => {
  const task = PREDEFINED_TASKS.find(t => t.value.toLowerCase() === taskValue.toLowerCase() || t.label.toLowerCase() === taskValue.toLowerCase());
  return task?.color || 'default';
};

// Get label for a task value
export const getTaskLabel = (taskValue: string): string => {
  const task = PREDEFINED_TASKS.find(t => t.value.toLowerCase() === taskValue.toLowerCase());
  return task?.label || taskValue;
};
